import { Typography } from "@mui/material";
import { type FC, type ReactNode } from "react";

interface INullGuardProps {
  children: ReactNode;
  value: number | null | undefined;
}

export const NullGuard: FC<INullGuardProps> = ({ children, value }) => {
  if (value === null || value === undefined) {
    return <Typography variant="caption">N/A</Typography>;
  }

  return children;
};
